import React from 'react'

import styles from './styles.module.scss'
import { HashLink as Link } from 'react-router-hash-link';
import banner_img from '../../../../images/education/education_banner.png'

const SearchJob = () => {
  return (
    <div className={styles.wrapper}>
      <img className={styles.wrapper_img} src={banner_img} alt='banner_img' />
      <div className={styles.wrapper_content}>
        <div className={styles.leftSide_wrap}>
          <div className={styles.leftSide}>
            <p className={styles.title}>Образование Generium</p>
          </div>
        </div>

        <div className={styles.rightSide}>
          <div className={styles.rightSide_wrap}>
            <p className={styles.text}>Построй карьеру<br/> в Generium<br/> до&nbsp;окончания вуза</p>
            <p className={styles.subtext}>Образовательные программы в Generium – это возможность получить знания<br/> и опыт от ведущих экспертов компании, познакомиться с различными направлениями перед выбором своего будущего профессионального развития и принять участие в работе над реальными проектами.</p>
            <Link className={styles.button} to='/students/education#form'>
              Подать заявку <span>&rarr;</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchJob
